import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { InputMask } from "@react-input/mask";

const UserList = () => {
	const [users, setUsers] = useState([]);
	const [allUsers, setAllUsers] = useState([]);
	const [loading, setLoading] = useState(true);
	const [searchText, setSearchText] = useState("");
	const [addShow, setAddShow] = useState(false);
	const [successShow, setSuccessShow] = useState(false);
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);
	const [organizations, setOrganizations] = useState([]);

	const [username, setUsername] = useState("");
	const [mail, setMail] = useState("");
	const [password, setPassword] = useState("");
	const [tcNo, setTcNo] = useState("");
	const [birthday, setBirthday] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [company, setCompany] = useState("");
	const [devices, setDevices] = useState([""]);
	const [allDevices, setAllDevices] = useState([]);
	const [filteredDevices, setFilteredDevices] = useState([]);

	const tableHeaders = ["", "Kullanıcı Adı", "E-posta", "Kurum", ""];

	const getUsers = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/panel-users`);
			const usersData = await response.json();
			console.log("Gelen kullanıcı verileri:", usersData);
			setAllUsers(usersData);
			setUsers(usersData);
			setLoading(false);
		} catch (error) {
			console.error("Kullanıcı verileri getirilirken bir hata oluştu:", error);
			setLoading(false);
		}
	};

	const getOrganizations = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/organisations`);
			const orgsData = await response.json();
			setOrganizations(orgsData);
		} catch (error) {
			console.error("Kurum verileri getirilirken bir hata oluştu:", error);
		}
	};

	const getDevices = async () => {
		try {
			const response = await fetch(`https://app.vivasmartcare.com/api/devices`);
			const devicesData = await response.json();
			setAllDevices(devicesData);
		} catch (error) {
			console.error("Cihaz verileri getirilirken bir hata oluştu:", error);
		}
	};

	useEffect(() => {
		getUsers();
		getOrganizations();
		getDevices();
	}, []);

	// Kurum değiştiğinde o kuruma ait cihazları filtrele
	useEffect(() => {
		if (company && allDevices.length > 0) {
			const filtered = allDevices.filter(
				(device) => device.organization === company
			);
			setFilteredDevices(filtered);
		} else {
			setFilteredDevices([]);
		}
	}, [company, allDevices]);

	// Filtreleme mantığı
	useEffect(() => {
		let filtered = allUsers;

		// Genel arama filtresi
		if (searchText.trim()) {
			const searchLower = searchText.toLowerCase().trim();
			filtered = filtered.filter((user) => {
				const username = (user.username || "").toLowerCase();
				const mail = (user.mail || "").toLowerCase();
				const company = (user.company || "").toLowerCase();
				return (
					username.includes(searchLower) ||
					mail.includes(searchLower) ||
					company.includes(searchLower)
				);
			});
		}

		setUsers(filtered);
	}, [searchText, allUsers]);

	const addHandleClose = () => {
		setAddShow(false);
		setUsername("");
		setMail("");
		setPassword("");
		setTcNo("");
		setBirthday("");
		setPhoneNumber("");
		setCompany("");
		setDevices([""]);
		setFilteredDevices([]);
	};

	const addHandleShow = () => setAddShow(true);

	const handleSuccess = () => {
		setSuccessShow(false);
		getUsers();
	};

	const addUser = async (e) => {
		e.preventDefault();

		setBtnDisabled(true);
		setShowSpinner(true);

		try {
			const response = await fetch("https://app.vivasmartcare.com/api/add-user", {
				method: "POST",
				body: JSON.stringify({
					username,
					mail,
					password,
					tcNo,
					birthday,
					phoneNumber,
					company,
					devices: devices.filter((d) => d.trim() !== ""),
				}),
				headers: { "Content-Type": "application/json" },
			});

			if (response.ok) {
				setSuccessShow(true);
				addHandleClose();
				getUsers();
			} else {
				alert("Kullanıcı eklenirken bir hata oluştu");
			}
		} catch (error) {
			console.error("Ekleme işlemi sırasında bir hata oluştu:", error);
			alert("Kullanıcı eklenirken bir hata oluştu");
		} finally {
			setBtnDisabled(false);
			setShowSpinner(false);
		}
	};

	return (
		<Layout>
			<div className="organizations-wrapper">
				<div className="device-table-wrapper">
					<div className="device-filter-inputs">
						<Form.Group>
							<Form.Control
								type="text"
								placeholder="Ara (İsim, E-posta, Kurum...)"
								value={searchText}
								onChange={(e) => setSearchText(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Button variant="primary" onClick={addHandleShow}>
								Yeni Üye Ekle
							</Button>
						</Form.Group>
					</div>
					<Table striped bordered hover responsive className="alarm-table">
						<thead>
							<tr>
								{tableHeaders.map((header, index) => (
									<th key={index}>{header}</th>
								))}
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td
										colSpan={tableHeaders.length}
										style={{ textAlign: "center" }}
									>
										<Spinner animation="border" variant="primary" />
									</td>
								</tr>
							) : users && users.length > 0 ? (
								users.map((user, index) => (
									<tr key={user._id || index}>
										<td className="table-id">{index + 1}</td>
										<td>{user.username || "-"}</td>
										<td>{user.mail || "-"}</td>
										<td>{user.company || "-"}</td>
										<td>
											<Link to={`/user-list/${user._id}`}>Düzenle</Link>
										</td>
									</tr>
								))
							) : (
								<tr>
									<td
										colSpan={tableHeaders.length}
										style={{ textAlign: "center" }}
									>
										{allUsers.length === 0
											? "Henüz kullanıcı bulunmamaktadır."
											: "Filtre kriterlerine uygun kullanıcı bulunamadı."}
									</td>
								</tr>
							)}
						</tbody>
					</Table>
				</div>
			</div>
			<Modal show={addShow} onHide={addHandleClose}>
				<Modal.Header>Yeni Üye Ekle</Modal.Header>
				<Modal.Body className="device-add-wrapper">
					<Form onSubmit={addUser}>
						<Form.Group>
							<Form.Control
								type="text"
								placeholder="Kullanıcı Adı Giriniz"
								value={username}
								required
								onChange={(e) => setUsername(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="email"
								placeholder="E-posta Adresi Giriniz"
								value={mail}
								required
								onChange={(e) => setMail(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="password"
								placeholder="Parola Giriniz"
								value={password}
								required
								onChange={(e) => setPassword(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<Form.Control
								type="text"
								placeholder="TC No Giriniz"
								maxLength={11}
								minLength={11}
								value={tcNo}
								onChange={(e) => setTcNo(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<label>Doğum Tarihi:</label>
							<Form.Control
								type="date"
								value={birthday}
								onChange={(e) => setBirthday(e.target.value)}
							/>
						</Form.Group>
						<Form.Group>
							<InputMask
								mask="+90__________"
								replacement={{ _: /\d/ }}
								value={phoneNumber}
								showMask
								onChange={(e) => setPhoneNumber(e.target.value)}
								className="form-control"
								placeholder="Telefon No Giriniz"
							/>
						</Form.Group>
						<Form.Group>
							<Form.Select
								value={company}
								onChange={(e) => setCompany(e.target.value)}
							>
								<option value="">Kurum Seçiniz</option>
								<option value="all">all</option>
								{organizations?.map((org, index) => (
									<option value={org.organisationName} key={index}>
										{org.organisationName}
									</option>
								))}
							</Form.Select>
						</Form.Group>
						<Form.Group>
							<label>Cihazlar:</label>
							{devices.map((device, index) => {
								// Bu select için mevcut cihazı hariç tutarak, diğer tüm eklenmiş cihazları filtrele
								const availableDevices = filteredDevices.filter((dev) => {
									// Boş değerleri geç
									if (!dev.deviceID) return false;
									// Eğer bu select'te zaten bu cihaz seçiliyse göster (değiştirme için)
									if (device === dev.deviceID) return true;
									// Diğer select'lerde (bu index hariç) seçili olan cihazları gösterme
									const usedInOtherSelects = devices.some((d, i) => i !== index && d === dev.deviceID);
									return !usedInOtherSelects;
								});

								return (
									<div
										key={index}
										style={{ display: "flex", gap: "10px", marginBottom: "10px" }}
									>
										<Form.Select
											value={device}
											onChange={(e) => {
												const selectedDevice = e.target.value;
												// Eğer seçilen cihaz zaten başka bir yerde kullanılıyorsa uyarı ver
												if (selectedDevice && devices.includes(selectedDevice) && device !== selectedDevice) {
													alert("Bu cihaz zaten eklenmiş!");
													return;
												}
												const newDevices = [...devices];
												newDevices[index] = selectedDevice;
												setDevices(newDevices);
											}}
											style={{ flex: 1 }}
											disabled={!company}
										>
											<option value="">Cihaz Seçiniz</option>
											{availableDevices.map((dev) => (
												<option value={dev.deviceID} key={dev._id || dev.deviceID}>
													{dev.deviceID}
												</option>
											))}
										</Form.Select>
										{devices.length > 1 && (
											<Button
												variant="danger"
												size="sm"
												type="button"
												onClick={() => {
													const newDevices = devices.filter(
														(_, i) => i !== index
													);
													setDevices(newDevices);
												}}
											>
												Sil
											</Button>
										)}
									</div>
								);
							})}
							<Button
								variant="outline-secondary"
								size="sm"
								type="button"
								onClick={() => {
									// Eğer tüm cihazlar zaten eklenmişse uyarı ver
									const allDevicesAdded = filteredDevices.every((dev) =>
										devices.includes(dev.deviceID)
									);
									if (filteredDevices.length > 0 && allDevicesAdded) {
										alert("Bu kuruma ait tüm cihazlar zaten eklenmiş!");
										return;
									}
									setDevices([...devices, ""]);
								}}
								style={{ marginTop: "10px" }}
								disabled={!company}
							>
								+ Cihaz Ekle
							</Button>
							{!company && (
								<small className="text-muted d-block mt-1">
									Lütfen önce bir kurum seçiniz
								</small>
							)}
						</Form.Group>
						<div className="button-wrapper">
							<Button variant="secondary" onClick={addHandleClose}>
								İptal
							</Button>
							<Button variant="primary" type="submit" disabled={btnDisabled}>
								Ekle
							</Button>
							{showSpinner && <Spinner animation="border" variant="primary" />}
						</div>
					</Form>
				</Modal.Body>
			</Modal>
			<Modal show={successShow} onHide={handleSuccess}>
				<Modal.Header closeButton></Modal.Header>
				<Modal.Body>Kullanıcı Başarıyla Eklendi.</Modal.Body>
			</Modal>
		</Layout>
	);
};

export default UserList;
